import React from 'react'
import { MDBIcon } from 'mdb-react-ui-kit'

import styles from './style.module.scss';

function AddFileButton() {
  return (
    <div className={styles.icon}>
        <MDBIcon fas icon="camera" />
    </div>
  )
}

export default AddFileButton